<template>
  <div class="child_">
    <a-form layout="horizontal" class="horizontal_item_" :form="form" @submit="ccSubmit">
      <!-- 合同信息始 -->
      <a-row v-show="type === '1'">
        <div id="start" class="title_">
          <div class="cutleft_">货款损失补偿险投保信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="20">
          <a-form-item class="m_span3" :label-col="{ span: 3 }" label="保险计划：">
            <a-select @change="coverageAmountTemp" class="planSelect" v-decorator="[
                'bracket',
                {
                  rules: [{ required: true, message: '请选择保险计划' }],
                },
              ]" placeholder="请选择保险计划">
              <a-select-option value="0.0046">计划一</a-select-option>
              <a-select-option v-if="dayBefore" value="0.0049">计划二</a-select-option>
              <a-select-option v-else value="0.0055">计划二</a-select-option>
              <a-select-option v-if="dayBefore" value="0.0058">计划三</a-select-option>
            </a-select>

            <span style="margin-left: 20px" v-if="brackePercentage!=0">费率：{{brackePercentage}}‰</span>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 合同信息末 -->
      <!-- 标的物存放地址始 -->
      <a-row v-show="type != '1'">
        <div id="start" class="title_">
          <div class="cutleft_">货款损失补偿险标的物存放地址</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="m_row">
          <a-col :span="6" class="m_span6">
            <a-form-item class="formItem" :label-col="{span: 10}" label="地址1（必填）">
              <a-select @change="(val) => handleProvinceChange(val, 'city1')" v-decorator="[
                  'province1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择省',
                      },
                    ],
                  },
                ]" class="w120_ mrg_r12_" placeholder="请选择省">
                <a-select-option v-for="item in provsData" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select @change="(val) => handleCityChange(val, 'district1','city1Options')" v-decorator="[
                  'city1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择市',
                      },
                    ],
                  },
                ]" class="w120_ mrg_r12_" placeholder="请选择市">
                <a-select-option v-for="item in city1Options" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select v-decorator="[
                  'district1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择区',
                      },
                    ],
                  },
                ]" class="w120_ mrg_r12_" placeholder="请选择区">
                <a-select-option v-for="item in district1Options" :key="item.value"
                  :value="`${item.text}-${item.value}`">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-input v-decorator="[
                  'maddress1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入详细地址',
                      },
                    ],
                  },
                ]" class="w200_" placeholder="请输入详细地址"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row class="m_row">
          <a-col class="m_span6" :span="6">
            <a-form-item class="formItem" :label-col="{span: 10}" label="地址2（选填）">
              <a-select @change="(val) => handleProvinceChange(val, 'city2')" v-decorator="[
                  'province2'
                ]" class="w120_ mrg_r12_" placeholder="请选择省">
                <a-select-option v-for="item in provsData" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select @change="(val) => handleCityChange(val, 'district2','city2Options')" v-decorator="[
                  'city2'
                ]" class="w120_ mrg_r12_" placeholder="请选择市">
                <a-select-option v-for="item in city2Options" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select v-decorator="[
                  'district2'
                ]" class="w120_ mrg_r12_" placeholder="请选择区">
                <a-select-option v-for="item in district2Options" :key="item.value"
                  :value="`${item.text}-${item.value}`">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-input v-decorator="[
                  'maddress2'
                ]" class="w200_" placeholder="请输入详细地址"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row class="m_row">
          <a-col :span="6" class="m_span6">
            <a-form-item label="地址3（选填）" :label-col="{span: 10}" class="formItem">
              <a-select @change="(val) => handleProvinceChange(val, 'city3')" v-decorator="[
                  'province3'
                ]" class="w120_ mrg_r12_" placeholder="请选择省">
                <a-select-option v-for="item in provsData" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select @change="(val) => handleCityChange(val, 'district3','city3Options')" v-decorator="[
                  'city3'
                ]" class="w120_ mrg_r12_" placeholder="请选择市">
                <a-select-option v-for="item in city3Options" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="3">
            <a-form-item>
              <a-select v-decorator="[
                  'district3'
                ]" class="w120_ mrg_r12_" placeholder="请选择区">
                <a-select-option v-for="item in district3Options" :key="item.value"
                  :value="`${item.text}-${item.value}`">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-input v-decorator="[
                  'maddress3'
                ]" class="w200_" placeholder="请输入详细地址"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-row>
      <!-- 标的物存放地址末 -->
      <!-- 合计保费 -->
      <!-- <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">预计保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="24">
          <a-form-item class="m_span3" :label-col="{ span: 3 }" label="预计保费">
            <a-input class="totalPremiumInput" :disabled="true" v-model="totalPremium" />
          </a-form-item>
        </a-col>
      </a-row> -->
    </a-form>
  </div>
</template>

<script>
  import moment from "moment";
  import validatorMixin from "@/mixins/validator";
  const tableData = [];
  const columns = [
    {
      title: "姓名",
      dataIndex: "name",
      scopedSlots: { customRender: "name" }
    },
    {
      title: "证件类型",
      dataIndex: "idType",
      scopedSlots: { customRender: "idType" }
    },
    {
      title: "证件号码",
      dataIndex: "idNumber",
      scopedSlots: { customRender: "idNumber" }
    },
    {
      title: "出生日期",
      dataIndex: "birthDate",
      scopedSlots: { customRender: "birthDate" }
    },
    {
      title: "性别",
      dataIndex: "gender",
      scopedSlots: { customRender: "gender" }
    },
    {
      title: "操作",
      dataIndex: "operation",
      fixed: "right",
      width: 200,
      scopedSlots: { customRender: "operation" }
    }
  ];
  export default {
    mixins: [validatorMixin],
    data() {
      this.handleIdCardBlurProxy = this.handleIdCardBlur.bind(this);
      return {
        columns,
        provsData: window.zlAddressOptionsP, //省选择
        city1Options: [],
        city2Options: [],
        city3Options: [],
        district1Options: [],
        district2Options: [],
        tableData,
        district3Options: [],
        planOffsetDay: 0,
        checkList: ["02", "01", "03", "04"],
        operationType: "",
        rangeConfig: {
          rules: [{ required: true, message: "请选择时间!" }]
        },
        insuredDTOs: [],
        includes03: false,
        policyRiskInfo: [],
        showAddInsuredModal: false,
        editingInsuredInfo: {},
        oneAmount: 0,
        twoAmount: 0,
        totalAmount: 0,
        brackePercentage: 0,
        policyPlanCode: "",
        xgzhongduan: false,
        wmzhongduan: false,
        yiwai: false,
        twoSave: false,
        oneSave: false,
        insureType: "C",
        brackePercentage1: "",
        brackePercentage2: "",
        destination1: "",
        ywbm: 5,
        nationAreaType: "",
        publicParms: {
          invoicePrintType: '',
          wenEmail: "",
          receiveEmail: "",
          cord: "",
          yeEmail: "",
          menberNum: "",
          holderName: "",
          pactType: "",
          destination1: 0,
          destination2: 0,
          destination3: 0,
          destination4: 0,
          destination5: 0,
          effectiveDate: '',
          expireDate: '',
          iptSumAmountFirst: 0,
          idNumber:"",//证件号
          birthDate: "", //出生日期
          idType: "", //身份证类型
          categoryid: "I", //投保人类型
          invoiceStart:'',//发票抬头
          invoiceSbh:'',//纳税人识别
          invoiceKhh:'',//开户行
          invoiceNumber:'',//开户行账号
          invoiceKpdz:'',//开户行地址
          invoiceKpdh:'',//开户行电话
          invoiceLxr:'',//联系人
          invoiceLxdh:'',//联系人电话
          invoiceYjdz:'',//邮寄地址
        },
        form: this.$form.createForm(this),
        dayBefore: false,
      };
    },
    props: {
      type: {// 1 费率计划 2地址
        type: String,
        default: '1'
      }
    },
    computed: {
      totalPremium: function () {
        let oneAmount = Number(this.oneAmount) || 0;
        let twoAmount = Number(this.twoAmount) || 0;
        return Math.ceil(oneAmount + twoAmount);
      },
    },
    created() {
      const { u, p } = this.$route.query;
      this.userParams = {
        //从地址中获取
        userId: u,
        productCode: p
      };
    },
    watch: {
      publicParms: {
        handler: function (news) {
          this.nationAreaType = 5
          if (news.destination1) {
            this.coverageAmountTemp();
          }
        },
        deep: true
      },
    },
    beforeDestroy() {
      this.$bus.$off("busPublicParms1");
      this.$bus.$off("policyInfo");
    },
    mounted() {
      this.$bus.$on("busPublicParms1", data => {
        this.publicParms = data
        this.$nextTick(() => {
          this.form.setFieldsValue({ //自动带出投保人名称
            salPolicyHolder: {
              name: this.publicParms.holderName
            }
          });
        })
      });
      this.$bus.$on("policyInfo", (data) => { //投保人信息
        const { bracket } = data.salPolicy
        const planCodes = data.planCodes
        const { province, city, detailaddress, district } = data.salPolicyHolder
        let provinceArr = province ? province.split(',') : []
        let cityArr = city ? city.split(',').map(item => item.split('-')[0]) : []
        let districtArr = district ? district.split(',').map(item => item.split('-')[0]) : []
        let detailaddressArr = detailaddress ? detailaddress.split(',') : []
        let brackePercentage2 = bracket == '2' ? 0.0045 : 0.0036
        let brackePercentage1 = planCodes && planCodes[2] == 'LBPLAU309800037' ? 0.0013 : 0.001
        if(!this.dayBefore) {
          brackePercentage1 = 0.001
        }
        let brackets = (brackePercentage1 + brackePercentage2).toString() //所选计划
        this.brackePercentage = (brackePercentage1 + brackePercentage2) * 1000
        this.form.setFieldsValue({ //地址
          province1: provinceArr[0],
          province2: provinceArr[1],
          province3: provinceArr[2],
          city1: cityArr[0],
          city2: cityArr[1],
          city3: cityArr[2],
          district1: districtArr[0],
          district2: districtArr[1],
          district3: districtArr[2],
          maddress1: detailaddressArr[0],
          maddress2: detailaddressArr[1],
          maddress3: detailaddressArr[2],
          bracket: brackets
        });
      });
      let bracket = this.dayBefore ? "0.0049" : "0.0046"
      this.form.setFieldsValue({
        insuredDTOs: {
          name: "仲利国际贸易（上海）有限公司"
        },
        bracket
      });
      this.brackePercentage = "4.60";
      this.coverageAmountTemp(bracket)
    },
    methods: {
      judgeData(value) {
        if (moment(value).isBefore(new Date())) {
          return moment(new Date()).add(1, "day")
        } else {
          return value
        }
      },
      judgeEffectiveDate(value, effectiveDate) {
        if (moment(value).isBefore(moment(effectiveDate).add(3, "year"))) {
          return value
        } else {
          return moment(effectiveDate).add(3, "year")
        }
      },

      //表单提交
      async ccSubmit() {
        let saveData = null
        this.form.validateFields((err, values) => {
          if (!err) {
            // this.oneSubmit(values);
            // this.twoSubmit(values);
            saveData = this.submitData(values)
          }
        });
        if(saveData) {
          return saveData
        }
      },
      submitData(values) {
        console.log(values)
        let province = values.province1;
        let city = values.city1;
        let district = values.district1;
        let detailaddress = values.maddress1;
        if (values.province2 && values.city2 && values.district2) {
          province += `,${values.city2}`
          city += `,${values.province2}`
          district += `,${values.district2}`
          detailaddress += `,${values.maddress2||''}`
        }
        if (values.province3 && values.city3 && values.district3) {
          province += `,${values.city3}`
          city += `,${values.province3}`
          district += `,${values.district3}`
          detailaddress += `,${values.maddress3||''}`
        }
        let bracket1 = "1"
        // 保费类别判断
        if (this.brackePercentage2 == 0.0045) {
          bracket1 = "2";
        }
        const saveData = {
          sourceType: values.bracket == "0.0055" ? "0.0058" : values.bracket,//计划
          nationAreaType: this.nationAreaType,
          creator: this.userParams.userId,
          oneAmount: this.oneAmount,
          province,
          city,
          district,
          detailaddress,
          twoAmount: this.twoAmount,
          policyPlanCode: this.policyPlanCode,
          bracket1,
          bracket2: this.brackePercentage1,
          salInsuredList: this.tableData,
          riskInfos: this.policyRiskInfo
        }
        console.log('data')
        return saveData
      },
      handleIdCardBlurProxy() { },
      //携带已经填好的参数过来
      changeType(value) {
        this.insureType = value;
        this.form.setFieldsValue({ salPolicyHolder: { type: value } });
      },
      initTime() {
        this.form.setFieldsValue({ expireDate: "" });
      },
      disabledDateRange(current) {
        let effectiveDate = this.form.getFieldsValue(["effectiveDate"])
          .effectiveDate;
        return (
          (current && current < effectiveDate) ||
          (current &&
            moment(effectiveDate)
              .add(3, "year")
              .add(1, "day") < current)
        );
      },

      StartdisabledDateRange(current) {
        return current && current < moment().endOf("day");
      },
      handleInsuredChange(options) {
        //新增人员组件传递信息
        const item = {
          ...options.data
        };
        if (options.type == "add") {
          this.tableData.push(item);
        } else {
          this.tableData[this.operationIndex] = item;
        }
        console.log("handleInsuredChange -> ", options, this.tableData);
      },
      coverageAmountTemp(value) {
        // 计算费率
        let salPolicy = this.form.getFieldsValue();
        let destination1 = this.publicParms.destination1 * 100000;
        let bracket = value - 0 || salPolicy.bracket - 0;

        let brackePercentage1;
        this.brackePercentage = (bracket * 1000).toFixed(2);
        
        if (bracket == 0.0046) {//46 55
          bracket = 0.0036;
        } else {
          bracket = bracket - 0.001;
        }
        brackePercentage1 = 0.001;
        console.log('2222', parseInt(destination1) * bracket)
        if (bracket && destination1) {
          // 保费计算 两种费率 两种保费 富邦的向下取整 利宝的向上取整
          let totalPremium = parseInt(destination1) * (bracket * 1000);
          let totalAmountPremium = parseInt(destination1) * (bracket * 1000 + 1);
          this.oneAmount = Math.floor(totalPremium/100000000); // 富邦的向下取整
          this.totalAmount = Math.ceil(totalAmountPremium/100000000); // 总保费向上取整
        }
        this.brackePercentage1 = brackePercentage1;
        this.brackePercentage2 = bracket;
        this.zhongduan(this.checkList);
      },
      handleProvinceChange(value, fieldKey) {
        var val = value.split("-")[1];
        this.form.setFieldsValue({ [fieldKey]: "" });
        let arr = window.zlAddressOptionsC.filter(item => item.provsCode == val)
        this[fieldKey + "Options"] = arr;
      },
      handleCityChange(value, fieldKey) {
        var val = value.split("-")[1];
        this.form.setFieldsValue({ [fieldKey]: "" });
        let arr = window.zlAddressOptionsD.filter(item => item.cityCode == val)
        this[fieldKey + "Options"] = arr;
      },
      handlePropertySelect(value) {
        var val = value.split("-")[1];
        this.form.setFieldsValue({ fastmailname: "" });
        this.companyCatagoryList = this.companyPropertyList.filter(
          item => item.name == val
        )[0].childrens;
      },
      rangePicker(values) {
        if (values) {
          let startData = this.form.getFieldValue("effectiveDate");
          let offsetDay = values.diff(startData, "days") + 1;
          this.planOffsetDay = offsetDay;
        }
      },
      splicingAddress(str1, str2, str3) {
        //拼接地址
        if (str2 && str1 && str3) {
          return `${str1},${str2},${str3}`;
        } else if (str2 && str1) {
          return `${str1},${str2}`;
        } else if (str1) {
          return `${str1}`;
        }
      },
      oneSubmit(values) {
        let params = {};
        let publicParms = JSON.parse(sessionStorage.getItem("publicParms"))
        // let effectiveDate = this.judgeData(publicParms.effectiveDate)
        // let expireDate = this.judgeEffectiveDate(publicParms.expireDate, effectiveDate)
        // let tickets = publicParms.originalTickets
        // console.error("publicParms==>", publicParms)
        params.salPolicy = {
          // tickets,
          sourceType: values.bracket,//计划
          nationAreaType: this.nationAreaType,
          // holderName: publicParms.holderName,
          // loanNo: publicParms.destination1, //保额
          // effectiveDate: moment(effectiveDate).format("YYYY-MM-DD"),
          // expireDate: moment(expireDate).format("YYYY-MM-DD"),
          // loanBeginTime: moment(publicParms.effectiveDate).format("YYYY-MM-DD"),
          // loanEndTime: moment(publicParms.expireDate).format("YYYY-MM-DD"),
          creator: this.userParams.userId,
          productCode: "01020002",  //财产险 保费向下取整
          planCode: "01020002",
          // noticeno: publicParms.cord,
          // policyPostName: publicParms.policyPostName,
          // mailno: publicParms.pactType,
          totalPremium: this.oneAmount,
        };
        //如果选则专票类型，则需要添加些字段
        if (publicParms.invoicePrintType == '02') {
          params.salPolicy = {
            ...params.salPolicy,
          }
        }
        // 保费类别判断
        if (this.brackePercentage2 == 0.0045) {
          // 保费类别判断
          params.salPolicy.bracket = "2";
        } else {
          params.salPolicy.bracket = "1";
        }
        params.salPolicyHolder = {
          // type: publicParms.categoryid,
          // name: publicParms.holderName,
          // idType: publicParms.idType,
          // idNumber: publicParms.idNumber || '110101198001010061',
          // telephone: publicParms.invoiceLxdh || '17800000000',
          // birthDate: publicParms.birthDate?moment(publicParms.birthDate).format("YYYY-MM-DD"):'1980-01-01',
          // bankName: publicParms.holderName,
          province: this.splicingAddress(
            values.province1,
            values.province2,
            values.province3
          ),
          city: this.splicingAddress(values.city1, values.city2, values.city3),
          district: this.splicingAddress(
            values.district1,
            values.district2,
            values.district3
          ),
          detailaddress: this.splicingAddress(
            values.maddress1,
            values.maddress2,
            values.maddress3
          ),
          // invoicetitle: `${publicParms.wenEmail.replace(/\s+/g, "")}@chailease.com.cn`,
          // email: publicParms.receiveEmail.replace(/\s+/g, ""),
          // invoiceno: `${publicParms.yeEmail.replace(/\s+/g, "")}@chailease.com.cn`,
          // useidnum: publicParms.menberNum,
          // invoiceprinttype: publicParms.invoicePrintType,
          // shopsname: publicParms.invoiceStart,
          // taxpayercertificateno: publicParms.invoiceSbh,
          // billingdepositbank: publicParms.invoiceKhh,
          // billingdepositbankaccount: publicParms.invoiceNumber,  //开户行账号
          // billingaddress: publicParms.invoiceKpdz,
          // fastmailtel: publicParms.invoiceLxdh,
          // fastmailaddress: publicParms.invoiceYjdz,
          // billingphone: publicParms.invoiceKpdh,   //开票电话
          // fastmailname: publicParms.invoiceLxr,  //联系人
        };
        params.salPolicyHolder.invoiceprinttype = publicParms.invoicePrintType == '01' ? '02' : '01';
        let province = values.province1;
        let city = values.city1;
        let district = values.district1;
        let detailaddress = values.maddress1;
        if (values.province2 && values.city2 && values.district2) {
          province = province + "," + values.province2;
          city = city + "," + values.city2;
          district = district + "," + values.district2;
          if (values.maddress2) {
            detailaddress = detailaddress + "," + values.maddress2;
          } else {
            detailaddress = detailaddress + ",";
          }
        }
        if (values.province3 && values.city3 && values.district3) {
          province = province + "," + values.province3;
          city = city + "," + values.city3;
          district = district + "," + values.district3;
          if (values.maddress2 && values.maddress3) {
            detailaddress = detailaddress + "," + values.maddress3;
          } else {
            detailaddress = detailaddress + ",";
          }
        }
        params.salPolicyHolder.province = province;
        params.salPolicyHolder.city = city;
        params.salPolicyHolder.district = district;
        params.salPolicyHolder.detailaddress = detailaddress;
        delete params.salPolicyHolder.birthDate;
        params.salInsuredList = [
          {
            name: "仲利国际贸易（上海）有限公司",
            type: "2",
            email: "cif_insurance@chailease.com.cn",
            relationship: "99",
            idNumber: "913101086778047729",
            idType: "14"
          }
        ];
        this.$emit('save', params)
        // this.$api.saveOrder(params).then(r => {
        //   if (r.data.returnCode == "00") {
        //     this.oneSave = false;
        //     //this.$message.success('保存成功');
        //     this.$emit("policyId", r.data.content);
        //   } else {
        //     this.oneSave = true;
        //     this.$emit("save", false)
        //   }
        // }).catch(r => { this.$emit("save", false) });
      },
      twoSubmit() {
        // let publicParms = JSON.parse(sessionStorage.getItem("publicParms"))
        // let expireDate = this.judgeEffectiveDate(publicParms.expireDate, effectiveDate)
        // let tickets = publicParms.originalTickets
        let twoAmount = this.publicParms.tickets > 0 ? (this.publicParms.tickets - 0) + (this.twoAmount - 0) : this.twoAmount
        // console.error("publicParms==>", publicParms)
        let params = {};
        params.salPolicy = {
          // holderName: publicParms.holderName,
          nationAreaType: this.nationAreaType,
          // bankName: publicParms.holderName,
          // effectiveDate: moment(effectiveDate).format("YYYY-MM-DD"),
          // expireDate: moment(expireDate).format("YYYY-MM-DD"),
          creator: this.userParams.userId,
          productCode: "LBFEIBUX", //费补险 
          planCode: this.policyPlanCode,
          // noticeno: publicParms.cord,
          // mailno: publicParms.pactType,
          bracket: this.brackePercentage1,
          totalPremium: twoAmount,
          // tickets: tickets, //汇款金额
          // policyPostName: publicParms.policyPostName,
          // destination: publicParms.destination1,
          // loanBeginTime: moment(publicParms.effectiveDate).format("YYYY-MM-DD"),
          // loanEndTime: moment(publicParms.expireDate).format("YYYY-MM-DD")
        };
        params.salPolicyHolder = {
          // type: publicParms.categoryid,
          // name: publicParms.holderName,
          // idType: publicParms.idType,
          // idNumber: publicParms.idNumber || '110101198001010061',
          // telephone: publicParms.invoiceLxdh,
          // birthDate: publicParms.birthDate?moment(publicParms.birthDate).format("YYYY-MM-DD"):'1980-01-01',
          // invoicetitle: `${publicParms.wenEmail.replace(/\s+/g, "")}@chailease.com.cn`,
          // email: publicParms.receiveEmail.replace(/\s+/g, ""),
          // invoiceno: `${publicParms.yeEmail.replace(/\s+/g, "")}@chailease.com.cn`,
          // useidnum: publicParms.menberNum,
          addresscode: "120107,000000,0001,0001",
          // invoiceprinttype: publicParms.invoicePrintType,
          // shopsname: publicParms.invoiceStart,
          // taxpayercertificateno: publicParms.invoiceSbh,
          // billingdepositbank: publicParms.invoiceKhh,
          // billingdepositbankaccount: publicParms.invoiceNumber,  //开户行账号
          // billingaddress: publicParms.invoiceKpdz,
          // fastmailtel: publicParms.invoiceLxdh,
          // fastmailaddress: publicParms.invoiceYjdz,
          // billingphone: publicParms.invoiceKpdh,   //开票电话
          // fastmailname: publicParms.invoiceLxr,  //联系人
        };
        params.salInsuredList = this.tableData;
        params.riskInfos = this.policyRiskInfo;

        this.$emit('save', params)
        // this.$api.saveOrder(params).then(r => {
        //   if (r.data.returnCode == "00") {
        //     this.twoSave = false;
        //     this.$emit("policyId", r.data.content);
        //   } else {
        //     this.twoSave = true;
        //     this.$emit("save", false)
        //   }
        // }).catch(r => { this.$emit("save", false) });
      },
      filterSex(val) {
        if (val == "男") {
          return "M";
        } else if (val == "女") {
          return "F";
        }
      },
      handleFileChange(file, fileList) {
        //文件导入
        if (fileList != undefined) {
          const formData = new FormData();
          formData.append("file", file);
          let _this = this;
          this.$api.parseInsuredExcel(formData).then(res => {
            let dataArr = res.data.content;
            dataArr.map(item => {
              let item_ = {
                name: item.insName,
                idType: "1",
                idNumber: item.insIdNumber,
                birthDate: item.insBirthday,
                gender: _this.filterSex(item.insGender)
              };
              this.tableData.push(item_);
            });
          });
        }
      }, 
      zhongduan(list) {
        this.xgzhongduan = list.indexOf("01") != -1;
        this.wmzhongduan = list.indexOf("03") != -1;
        var str = "3人/单";
        if (this.yiwai) {
          if (this.publicParms.destination1 - 0 > 5000000) {
            this.insureMax = "15";
          } else if (this.publicParms.destination1 - 0 > 3000000) {
            this.insureMax = "10";
          } else if (this.publicParms.destination1 - 0 > 2000000) {
            this.insureMax = "7";
          } else if (this.publicParms.destination1 - 0 > 1000000) {
            this.insureMax = "5";
          } else {
            this.insureMax = "3";
          }
          if (this.insureMax != "3") {
            str = "3-" + this.insureMax + "人/单";
          }
          this.policyInsureMax = str;
          this.form.setFieldsValue({ policyInsureMax: this.policyInsureMax });
        }
        this.getProductCode();
      },
      resetForm() {
        this.form.resetFields();
      },
      checkFields() {
        //校验form
        this.form.validateFields((err) => {
          if (!err) {
            this.$emit("checked", true);
          } else {
            this.$emit("checked", false);
          }
        });
      },
      setFangAnCode() {
        if(!this.dayBefore) {
          this.fangAnCode = "LBPLAN309800007"; // 租金补偿
          this.calculate();
          return
        }
        if (this.brackePercentage1 == '0.0013') {
          // 租金补偿+雾霾营业中断
          this.fangAnCode = "LBPLAU309800037";
        } else {
          this.fangAnCode = "LBPLAN309800007"; // 租金补偿
        }
        this.calculate();
      },
      getProductCode() {
        if(!this.dayBefore) {
          // 租金补偿
          this.policyPlanCode = "LBPLAN309800007";
          this.setFangAnCode();
          return
        }
        if (this.brackePercentage1 == '0.0013') {
          // 租金补偿+意外+雾霾
          this.policyPlanCode = "LBPLAU309800037";
        } else {
          // 租金补偿
          this.policyPlanCode = "LBPLAN309800007";
        }
        this.setFangAnCode();
      },
      calculate() {
        if((this.publicParms.destination||0) == 0) {
          return
        }
        //保费计算
        let data = {
          RentingBjoece: (this.publicParms.destination || 0) - 0,
          fangAnCode: this.fangAnCode
        };
        this.$api.zhongliGetCelPrice(data).then(res => {
          if (res.data.returnData) {
            let param = {};
            let planJson = res.data.returnData[0];
            param.plan001 = planJson["001"];
            param.plan003 = planJson["003"];
            param.plan004 = planJson["004"];
            param.plan005 = planJson["005"];
            param.plan006 = planJson["006"];
            param.plan007 = planJson["007"];
            param.plan008 = planJson["008"];
            param.plan009 = planJson["009"];
            param.plan010 = planJson["010"];
            param.plan011 = planJson["011"];
            param.plan012 = planJson["012"];
            param.plan0022 = planJson["0022"];
            param.plan0021 = planJson["0021"];
            // 多出的加到费补险
            let extraAmount = this.totalAmount - this.oneAmount - planJson["003"]
            if(extraAmount < 0) {
              extraAmount = 0
            }
            this.twoAmount = Number(planJson["003"]) + Number(extraAmount)
            console.log('this.twoAmount', this.oneAmount, this.twoAmount, extraAmount)
            this.$emit("totalPremium", Math.ceil(this.oneAmount), this.twoAmount);
            this.initRiskInfo(param);
          }
        });
      },
      initRiskInfo(param) {
        this.policyRiskInfo = []; //清空险种信息
        // 添加险种
        this.addRiskInfo(
          param.plan004,
          param.plan001,
          "15M00075,00089",
          "LBPLAN309800007"
        ); // 租金补偿
        if (this.dayBefore && this.brackePercentage1 == '0.0013') {
          if (this.wmzhongduan) {
            // 雾霾
            this.addRiskInfo(
              param.plan005,
              param.plan0021,
              "01S00065,00603",
              "LBPLAU309800037"
            ); // 雾霾
          }

          if (this.yiwai) {
            // 意外
            this.addYiWaiRiskInfo();
          }
        }
      },
      addYiWaiRiskInfo() {
        this.addRiskInfo("3000", "1", "27S00115,00523", "LBPLAU309800021");
        this.addRiskInfo("300000", "1", "27S00114,00524", "LBPLAU309800021");
        this.addRiskInfo("100000", "1", "27M0002,0059", "LBPLAU309800021");
        this.addRiskInfo("100000", "1", "27M0002,0060", "LBPLAU309800021");
      },
      addRiskInfo(amount, premiumAmt, riskCode, dutyCode) {
        var addItem = {
          amount: amount,
          premiumAmt: premiumAmt,
          riskCode: riskCode,
          dutyCode: dutyCode
        };
        this.policyRiskInfo.push(addItem);
      }
    }
  };
</script>

<style scoped lang="scss">
  @media screen and (min-width: 500px) {
    $themeC: rgba(254, 143, 45, 1);

    .child_ {
      .mrg_r12_ {
        margin-right: 12px;
      }

      .w200_ {
        width: 200px;
      }

      .w120_ {
        width: 120px;
      }

      .wid_150 {
        width: 150px;
      }

      .marL_10 {
        margin-left: 10px;
      }

      .title_ {
        margin: 30px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .cutleft_ {
          font-size: 16px;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          // width: 10%;
        }

        .cutoff_ {
          // width:90%;
          flex: 1;
          height: 5px;
          background: #f0f0f0;
        }
      }

      .operation {
        text-align: center;
      }

      .operation span {
        display: inline-block;
        background-color: #fe8f2d;
        color: #fff;
        border-radius: 3px;
        padding: 3px 10px;

        &:last-child {
          margin-left: 20px;
        }
      }

      .btn_list {
        display: flex;
        justify-content: center;

        .btn_ {
          margin: 19px;
          border: 1px solid $themeC;
          width: 150px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;

          .btn_a {
            flex: 1;
            text-align: center;
            color: $themeC;
          }
        }
      }

      .btn_color {
        background: $themeC;
        border: 1px solid $themeC;
      }

      .pl_10 {
        padding-left: 10px;
      }

      .planSelect {
        width: 330px;
      }

      .totalPremiumInput {
        width: 300px;
      }
    }
  }

  // 移动端适配
  @media screen and (max-width: 500px) {
    .child_ {
      .planSelect {
        width: 170px;
      }

      .ant-col-10 {
        width: 100%;
      }

      .ant-col-20 {
        width: 100%;
      }

      .ant-form-item-label {
        line-height: 40px;
        font-size: 12px;
      }

      .ant-col-offset-2 {
        margin-left: 0;
      }

      .ant-form-item-required::before {
        margin-right: 0px;
      }

      .m_span3 {
        .ant-col-3 {
          width: 25%;
        }
      }

      .m_row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .m_span6 {
          width: 220px;

          .formItem {
            .ant-col {
              color: red;
            }
          }
        }

        .ant-col-6 {
          width: 220px;
        }

        .ant-col-3 {
          width: 130px;
        }
      }
    }
  }
</style>
<style scoped>
  @media screen and (max-width: 500px) {
    .formItem>>>.ant-form-item-label {
      width: 100px;
      white-space: nowrap;
    }
  }
</style>